import React, { useEffect, useState } from "react";
import "./Objectives.css";
import { Button, Form } from "react-bootstrap";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Success_Toster from "../../../../../../common/common_modal/success_toster/Success_Toster";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import {
  GetSingle,
  ObjectiveInvoiceGenerate,
  Update,
  GetAll,
  Delete,
  Create,
} from "../../../../../../features/admin/quality_management/structural_requirement/objective/Slice";
import { FixIDS } from "../../../../../../utils/fixIDS";
import { faEye, faUpload, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ClipLoader } from "react-spinners";
import Certification_Modal from "../../../../../../common/common_modal/certification_modal/Certification_Modal";
function Objectives({ handleClose }) {
  const [success, setSuccess] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [success]);

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    watch,
    formState: { errors },
  } = useForm();

  const singledata = useSelector((state) => state.objective.singledata);
console.log(singledata,"singledata singledata");

  const existingFile = singledata || null;
  useEffect(() => {
    dispatch(GetSingle());
  }, [dispatch]);

  useEffect(() => {
    reset(singledata);
  }, [singledata]);

  const [loader, setLoder] = useState(false);

  const onSubmit = async (data) => {
    const formData = new FormData();
    formData.append("name", data?.image[0]);

    try {
      await dispatch(Create(formData)).unwrap();
      await dispatch(GetSingle());
      handleCloseUploadModal();
    } catch (err) {
      console.error("Upload failed:", err);
      alert("Upload failed");
    }
  };

  const handleDownloadInvoice = async (singledata) => {
    try {
      setLoder(true);
      const res = await dispatch(
        ObjectiveInvoiceGenerate({ id: singledata?.id }),
      );

      const fileUrl = `${process.env.REACT_APP_IMG_URL}${res?.payload?.data}`;

      // Fetch the file as blob
      const response = await fetch(fileUrl, { mode: "cors" });
      if (!response.ok) throw new Error("Network response was not ok");

      const blob = await response.blob();

      // Create a temporary object URL from blob
      const url = window.URL.createObjectURL(blob);
      setLoder(false);
      // Create a temporary anchor element to trigger the download
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Objective.pdf`); // you can make this dynamic
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
      alert("Failed to download invoice");
    }
  };

  const permissions = useSelector((state) => state.auth.permissions);

  const haveReadPermission = permissions?.includes(FixIDS.objectives.List);
  const haveAddPermission = permissions?.includes(FixIDS.objectives.Add);

  const [showViewModal, setShowViewModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  /* ================= FETCH DATA ================= */
  useEffect(() => {
   dispatch(GetSingle());
  }, [dispatch]);

  /* ================= HELPERS ================= */
  const getImageUrl = (path) => {
    if (!path) return "/assets/images/other/dummy-image.png";
    return path.startsWith("http")
      ? path
      : `${process.env.REACT_APP_IMG_URL}${path}`;
  };

  const getFileName = (path) => {
    if (!path) return "";
    return path.split("/").pop();
  };

  const isPdf = (filePath = "") => filePath.toLowerCase().endsWith(".pdf");

  /* ================= FILE CHANGE ================= */
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = [
      // "application/pdf",
      "image/jpeg",
      "image/png",
      "image/webp",
    ];

    if (!allowedTypes.includes(file.type)) {
      alert(" image files are allowed");
      return;
    }

    setSelectedFile(file);
    setPreviewUrl(URL.createObjectURL(file));
  };

  /* ================= UPLOAD ================= */
  const handleUpload = async () => {
    if (!selectedFile) return;

    const formData = new FormData();
    formData.append("name", selectedFile);

    try {
      await dispatch(Create(formData)).unwrap();
      await dispatch(GetSingle());
      handleCloseUploadModal();
    } catch (err) {
      console.error("Upload failed:", err);
      alert("Upload failed");
    }
  };

  /* ================= DELETE ================= */
  const handleDelete = async () => {
    if (!existingFile?.id) return;

    try {
      await dispatch(Delete(existingFile.id)).unwrap();
      await dispatch(GetSingle());
    } catch (err) {
      console.error("Delete failed:", err);
      alert("Delete failed");
    }
  };

  /* ================= CLOSE MODAL ================= */
  const handleCloseUploadModal = () => {
    setShowUploadModal(false);
    setSelectedFile(null);
    setPreviewUrl(null);
  };

  return (
    <>
      <>
        {haveReadPermission && (
          <section className="Imperiality Quality_Policy">
            <div className="back_div">
              <Common_Back_Btn backText="Objective" />
            </div>

            <div className="white_container customer_section">
              {/* ================= NOTE ================= */}
              <div className="note_text_holder">
                <p>
                  Our company is committed to maintaining the highest standards
                  of accuracy, reliability, and integrity in all laboratory
                  operations. We ensure continuous improvement of our processes,
                  compliance with quality standards, and customer satisfaction
                  through effective documentation and controlled file
                  management.
                </p>
              </div>

              {/* ================= FILE VIEW ================= */}
              {existingFile?.name ? (
                <div className="file_section">
                  <div className="row">
                    <div className="col-md-4">
                      <Form.Group className="form_group file_field">
                        <div className="image_holder">
                          {isPdf(existingFile.name) ? (
                            <iframe
                              src={getImageUrl(existingFile.name)}
                              // width="100%"
                              // height="250"
                              width="100%"
                              height="150px"
                              title="Quality Policy PDF"
                            />
                          ) : (
                            <img
                              className="img_preview"
                              src={getImageUrl(existingFile.name)}
                              alt="Quality Policy"
                              onError={(e) =>
                                (e.target.src =
                                  "/assets/images/other/dummy-image.png")
                              }
                            />
                          )}
                        </div>

                        <div className="span_text_holder">
                          <span>{getFileName(existingFile.name)}</span>

                          <div className="d-flex gap-3 mt-2">
                            <span
                              className="green_text"
                              onClick={() => setShowViewModal(true)}
                            >
                              <FontAwesomeIcon icon={faEye} /> View
                            </span>

                            <span className="red_text" onClick={handleDelete}>
                              <FontAwesomeIcon icon={faTrashCan} /> Delete
                            </span>
                          </div>
                        </div>
                      </Form.Group>
                    </div>
                  </div>
                </div>
              ) : (
                /* ================= UPLOAD BUTTON ================= */
                <div className="permission_btn_holder">
                  <Button
                    className="upload_btn"
                    onClick={() => setShowUploadModal(true)}
                  >
                    <FontAwesomeIcon icon={faUpload} className="me-2" />
                    Upload File
                  </Button>
                </div>
              )}
            </div>
          </section>
        )}

        {/* ================= VIEW MODAL ================= */}
        {haveReadPermission && (
          <Certification_Modal
            show={showViewModal}
            onHide={() => setShowViewModal(false)}
            modalHeadingText="View Objective"
            imgSrc={previewUrl || getImageUrl(existingFile?.name)}
            btnText="Download"
            title="Objective"
          />
        )}

        {/* ================= UPLOAD MODAL ================= */}
        {haveAddPermission && showUploadModal && (
          <div className="modal common_modal fade show d-block" tabIndex="-1">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Upload Objective</h5>
                    <button
                      className="btn-close"
                      onClick={handleCloseUploadModal}
                    />
                  </div>

                  <div className="modal-body">
                    <Form.Control
                      type="file"
                      {...register("image", {
                        validate: (value) => {
                          if (typeof value === "string" && value) return true;

                          if (value && value.length > 0) return true;

                          return "File is required";
                        },
                      })}
                      accept="*"
                    />

                    {(() => {
                      const fileValue = watch("image");

                      // URL for preview
                      const fileUrl =
                        typeof fileValue === "string"
                          ? process.env.REACT_APP_IMG_URL + fileValue
                          : fileValue?.length > 0
                          ? URL.createObjectURL(fileValue[0])
                          : null;

                      // Type detection
                      const fileType =
                        typeof fileValue === "string"
                          ? fileValue.toLowerCase()
                          : fileValue?.[0]?.type;

                      if (!fileUrl) return null;

                      return (
                        <div className="preview-container">
                          {/* IMAGE */}
                          {(fileType?.includes("image") ||
                            fileType?.endsWith(".jpg") ||
                            fileType?.endsWith(".jpeg") ||
                            fileType?.endsWith(".png")) && (
                            <img
                              src={fileUrl}
                              alt="Preview"
                              className="image-preview"
                              style={{ maxWidth: "100px" }}
                            />
                          )}

                          {/* PDF */}
                          {(fileType === "application/pdf" ||
                            fileType?.endsWith(".pdf")) && (
                            <iframe
                              src={fileUrl}
                              style={{ maxWidth: "100px" }}
                              title="PDF"
                            />
                          )}

                          {/* WORD */}
                          {(fileType?.includes("word") ||
                            fileType?.endsWith(".doc") ||
                            fileType?.endsWith(".docx")) && (
                            <div>
                              <p>Word preview not supported</p>
                              <a
                                href={fileUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Open / Download Word File
                              </a>

                              <iframe
                                src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                                style={{ maxWidth: "100px" }}
                                title="Word Preview"
                              />
                            </div>
                          )}

                          {/* EXCEL */}
                          {(fileType?.includes("spreadsheet") ||
                            fileType?.endsWith(".xlsx") ||
                            fileType?.endsWith(".xls")) && (
                            <div>
                              <p>Excel preview not supported</p>
                              <a
                                href={fileUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Open / Download Excel File
                              </a>
                            </div>
                          )}
                        </div>
                      );
                    })()}
                  </div>

                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={handleCloseUploadModal}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      // disabled={!selectedFile}
                      type="submit"
                      // onClick={handleUpload}
                    >
                      Upload
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        )}
      </>
      {/* <section className="Imperiality Quality_Policy Objectives">
        <div className="back_div">
          <Common_Back_Btn backText="Objectives" />
        </div>
        {haveReadPermission && (
          <Form onSubmit={handleSubmit(onSubmit)}>
            <div className="white_container customer_section">
            
              <div className="note_text_holder">
                <p>
                  Our company is committed to maintaining the highest standards
                  of accuracy, reliability, and integrity in all laboratory
                  operations. We ensure continuous improvement of our processes,
                  compliance with quality standards, and customer satisfaction
                  through effective documentation and controlled file management
                  — including secure addition and deletion of files as per QMS
                  guidelines.
                </p>
              </div>

         
              <div className="file_section">
                <div className="row justify-content-center">
                  <div className="col-md-8">
                    <div className="row">
                      <div className="col-md-12 ">
                        <Form.Group className="form_group file_field">
                          <Form.Control
                            placeholder="Type Objectives..."
                            as="textarea"
                            rows={8}
                            {...register("name", {
                              required: "Objectives Name is required",
                            })}
                          />
                        </Form.Group>

                        {errors.name && (
                          <small className="text-danger">
                            {errors.name.message}
                          </small>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="permission_btn_holder">
                {!success ? (
                  <>
                    {loader ? (
                      <>
                        <div className="text-center">
                          <ClipLoader />
                        </div>
                      </>
                    ) : (
                      <Button
                        type="button"
                        className="permission_btn No_btn"
                        onClick={() => handleDownloadInvoice(singledata)}
                      >
                        Generete PDF
                      </Button>
                    )}

                    {haveAddPermission && (
                      <Button
                        type="submit"
                        className="permission_btn Yes_btn"
                        // onClick={() => {
                        //   setSuccess(true);
                        // }}
                      >
                        Save Objectives
                      </Button>
                    )}
                  </>
                ) : (
                  <Success_Toster
                    successText={"Save Objectives Successfully!"}
                  />
                )}
              </div>
            </div>
          </Form>
        )}
      </section> */}
    </>
  );
}

export default Objectives;
